module.exports = __webpack_public_path__ + "static/img/avatar-bar.bd28343f.png";